export default "__VITE_ASSET__9742dfc1__"